import { makeStyles } from '@fluentui/react';

export const useStyles = makeStyles((theme) => ({
  signatureImage: {
    borderRadius: 5,
  },
}));
